import { motion } from 'framer-motion';

/**
 * A subtle browser chrome that frames a website screenshot so it reads as
 * "a piece of work we shipped" rather than "our brand".
 */
export const BrowserFrame = ({
  src,
  alt,
  aspect = 'aspect-[16/10]',
  scaleOnHover = true,
  className = '',
  chromeTone = 'light',
  url = '',
}) => {
  const isDark = chromeTone === 'dark';
  return (
    <div className={`relative overflow-hidden rounded-[1.25rem] border ${isDark ? 'border-paper/15 bg-ink/60' : 'border-border bg-secondary/60'} shadow-card ${className}`}>
      {/* Chrome bar */}
      <div className={`flex items-center gap-1.5 px-4 py-2 border-b ${isDark ? 'border-paper/10 bg-ink/80' : 'border-border/70 bg-background/70'} backdrop-blur`}>
        <div className="flex items-center gap-1.5 shrink-0">
          <span className="w-2.5 h-2.5 rounded-full bg-[#ff5f56]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[#ffbd2e]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[#27c93f]" />
        </div>
        <div className={`ml-3 flex-1 flex items-center justify-center h-6 rounded-md ${isDark ? 'bg-paper/10' : 'bg-foreground/[0.04]'}`}>
          {url && <span className="text-[10px] md:text-[11px] font-mono text-muted-foreground/80 truncate px-2">{url.replace(/^https?:\/\//, '')}</span>}
        </div>
      </div>
      {/* Image */}
      <div className={`relative ${aspect} overflow-hidden`}>
        <motion.img
          src={src}
          alt={alt}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-contain object-center"
          initial={{ scale: 1.02 }}
          whileHover={scaleOnHover ? { scale: 1.05 } : {}}
          transition={{ duration: 1.6, ease: [0.7, 0, 0.2, 1] }}
        />
      </div>
    </div>
  );
};

export default BrowserFrame;
